import React from "react";
import Button from "../../Components/Utils/Button/Button";
import LibraryDialog from "./LibraryDialog";
import styles from "./Library.module.css";

export type FolderDialogState =
  | { mode: "create" }
  | { mode: "rename"; id: string; title: string };

type FolderNameDialogProps = {
  dialog: FolderDialogState | null;
  name: string;
  busy?: boolean;
  onNameChange: (value: string) => void;
  onClose: () => void;
  onConfirm: () => void;
};

const FolderNameDialog = ({ dialog, name, busy, onNameChange, onClose, onConfirm }: FolderNameDialogProps) => (
  <LibraryDialog
    isVisible={!!dialog}
    title={dialog?.mode === "rename" ? "Rename folder" : "New folder"}
    onClose={onClose}
  >
    <div className={styles.dialogBody}>
      <input
        value={name}
        placeholder="Folder name"
        autoFocus
        aria-label="Folder name"
        onChange={(event) => onNameChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") onConfirm();
        }}
      />
      <div className={styles.dialogActions}>
        <Button colour="#fff" textColour="#24394F" border="#d5dde6" clickHandler={onClose}>Cancel</Button>
        <Button disabled={!name.trim() || busy} clickHandler={onConfirm}>
          {dialog?.mode === "rename" ? "Rename" : "Create"}
        </Button>
      </div>
    </div>
  </LibraryDialog>
);

export default FolderNameDialog;
